module.exports = __webpack_public_path__ + "static/media/revista-septiembre2008.f51ef00f.png";